import React from 'react';
import { IMAGES } from '../data/offer';
export function Testimonial() {
  return <section className="w-full bg-sand" data-id="element-136" data-mp="z5r9lz7v1trp">
      <div className="mx-auto max-w-4xl px-4 py-16 sm:px-6 sm:py-20" data-id="element-137" data-mp="z4ol1xy0g3ey">
        <blockquote className="font-display text-xl font-bold leading-snug tracking-tight text-navy-950 sm:text-3xl" data-id="element-138" data-mp="l6rmwx3wroy6">
          «Venía del tenis y perdía contra todos. Esta guía me enseñó que el pickleball es otro
          deporte. En dos semanas pasé de ser el que siempre perdía a{' '}
          <span className="bg-lime-400 px-1" data-id="element-139" data-mp="g6viiwratvi3">ganar el torneo de mi club local</span>.»
        </blockquote>
        <figcaption className="mt-7 flex items-center gap-4" data-id="element-140" data-mp="1ir444za4654">
          <img src={IMAGES.avatar} alt="Juan M., jugador de pickleball en Buenos Aires" className="h-14 w-14 rounded-full object-cover" data-id="element-141" data-mp="1geer6r6yti1" />
          <div className="text-sm" data-id="element-142" data-mp="3onqia3csuzry">
            <p className="font-semibold text-navy-950" data-id="element-143" data-mp="3tls3ouxp7b6l">Juan M.</p>
            <p className="text-navy-600" data-id="element-144" data-mp="3to4hqx0c51ed">Buenos Aires, Argentina</p>
          </div>
        </figcaption>
      </div>
    </section>;
}